module.exports = __webpack_public_path__ + "static/urban13-9f39252a7e7600ee738cc19ab8e96c72.jpg";